import { Component, ViewChild, Inject, OnInit, OnDestroy, DOCUMENT } from '@angular/core';

import { LanguageService } from 'src/app/services/language/language.service';
import { takeUntil } from 'rxjs/operators';
import { LanguageId } from 'src/app/types/language.type';
import { AprimoVideo } from 'src/app/shared/utils/aprimo-video.util';
import { AprimoVideoComponent } from 'src/app/shared/components/aprimo-video/aprimo-video.component';
import { BaseComponent } from '../../base/component/base-component';
import { getWelcomeVideo, WELCOME_VIDEO_POSTER } from './welcome-video.config';

@Component({
  selector: 'mpp-welcome-video',
  templateUrl: './welcome-video.component.html',
  styleUrls: ['./welcome-video.component.scss'],
  standalone: false,
})
export class WelcomeVideoComponent extends BaseComponent implements OnInit, OnDestroy {
  constructor(
    private languageService: LanguageService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    super();
  }

  @ViewChild('videoContent') videoContent: AprimoVideoComponent;
  dataState = 'is-disabled';
  video: AprimoVideo;
  poster = WELCOME_VIDEO_POSTER;
  currentLanguage: string;

  ngOnInit(): void {
    this.languageService.selectedLanguageId$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((language: LanguageId) => this.setVideo(language));
  }

  playVideo(): void {
    if (!this.video) {
      return;
    }
    this.dataState = 'is-active';
    this.document.body.classList.add('no-scroll--video');
    this.videoContent?.play();
  }

  stopVideo(): void {
    this.dataState = 'is-disabled';
    this.document.body.classList.remove('no-scroll--video');
    this.videoContent?.pause();
  }

  setVideo(languageId: LanguageId): void {
    this.currentLanguage = this.languageService.getCurrent2LettersLanguage();
    this.video = getWelcomeVideo(languageId);
    if (!this.video) {
      this.stopVideo();
    }
  }
}
